import { Component, OnInit, ViewChild, } from "@angular/core";
import { VernostServiceService } from "../../../services/vernost-service.service";
import { MatInput } from "@angular/material";
import { DatePipe } from "@angular/common";
import { Router } from "@angular/router";
import { saveAs } from "file-saver";

@Component({
  selector: "app-dsr-oneg",
  templateUrl: "./dsr-oneg.component.html",
  providers: [DatePipe]
})
export class DsrOneGComponent implements OnInit {
  @ViewChild("input3", { read: MatInput }) input3: MatInput;
  @ViewChild("input4", { read: MatInput }) input4: MatInput;

  screentitle: string = "DSR";
  invaliddate = false;
  showsingle1 = true;
  showMultiple1 = true;
  final;
  downd = true;
  searchlist: boolean = true;
  mydate = new Date();
  journeydate = false;
  noFileToDownloadErrorMessage: string = "Sorry the file Could not be downloaded. Please contact Server Center."
  isNoFileToDownloadError: boolean = false;
  searchDetails;
  tomorrow1;
  isOrd = false;
  isPnr = false;
  disableBtn = true;
  bookingdate = false;
  tomorrow;
  p: number = 1;
  search_result_list: any = [];
  order_Id_list: any = [];
  search_detail_list: any = [];
  existingbooking: boolean = true;

  loader: any = false;
  isloader: any = false;
  uid;
  cancelbtn;
  noresult: any = "";
  Errmessage: any = "";
  CancellationMiles: any = 0;
  CancellationMilesInbound: any = 0;
  newDate: any = new Date();
  myDate: any = new Date();
  totalItems: number = 1;
  sendEmailReports:any = [];
  constructor(
    private vernostService: VernostServiceService,
    private router: Router,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    this.cancelbtn = true;
    this.uid = localStorage.getItem("uid");
    if (this.uid == "" || this.uid == undefined) {
      this.router.navigate(["/login"]);
    }
    this.searchDetails = {
      bookingdate_from: "",
      bookingdate_to: ""
    };
  }
  ngAfterContentInit() {
    this.searchDetails.bookingdate_to = new Date();
    this.searchDetails.bookingdate_from = new Date();
    this.final = this.searchDetails.bookingdate_to.setDate(
      this.searchDetails.bookingdate_to.getDate()
    );
    this.final = new Date(this.final);
    this.IsEmptyValue = true;
   // this.searchData();
  }
  searchForm() {
    this.existingbooking = true;
    this.Errmessage = "";
    this.searchData();
    this.CancellationMilesInbound = 0;
    this.CancellationMiles = 0;
  }
  searchData() {
    this.noresult = "";
    this.loader = true;
    this.searchlist = false;
    this.cancelbtn = true;
    this.search_result_list = [];
    this.order_Id_list = [];
    this.search_detail_list = [];
    this.sendEmailReports = [];
    var Todate = this.searchDetails.bookingdate_to;
    if (Todate != "") {
      Todate.setDate(Todate.getDate());
    }
    this.searchDetails.bookingdate_from = this.datePipe.transform(
      this.searchDetails.bookingdate_from,
      "yyyy-MM-dd"
    );
    Todate = this.datePipe.transform(Todate, "yyyy-MM-dd");
    var boofrom = this.searchDetails.bookingdate_from;
    var bookto = Todate;
    var data = {
      fromdate: boofrom,
      todate: bookto,
      pagination: this.p
    };
     console.log("Data::::",data);
    this.vernostService.getDsrReportList(data).subscribe(response => {
      var Data = response;
      var count = Data[0].count;	  
      this.totalItems = count;
	  this.search_detail_list = Data[0].result;
      if (
        this.search_detail_list.length == 0 ||
        this.search_detail_list == undefined ||
        this.search_detail_list == ""
      ) {
        // alert("here");git 
        this.noresult = "Result Not Found";
        this.loader = false;
        //document.getElementById("noresulrErr").innerHTML = "Result Not Found";
      } else {
        this.loader = false;
      }
    });
  }
  IsEmptyValue: boolean = false;
  isEmpty() {
    if (
      ((this.searchDetails.bookingdate_from == "" || this.searchDetails.bookingdate_from == null) ||
        (this.searchDetails.bookingdate_to == "" || this.searchDetails.bookingdate_to == null))
    ) {
      this.IsEmptyValue = false;
    } else {
      this.IsEmptyValue = true;
    }
    if(((this.searchDetails.bookingdate_from != "" && this.searchDetails.bookingdate_from != null) &&
    this.searchDetails.bookingdate_to == "" || this.searchDetails.bookingdate_to == null) || ((this.searchDetails.bookingdate_from == "" || this.searchDetails.bookingdate_from == null) &&
    this.searchDetails.bookingdate_to != "" && this.searchDetails.bookingdate_to != null) ){
      this.IsEmptyValue = false;
    }
  }

  pageCount(count) {
    this.p = count;
    this.searchData();
    console.log("P:::", this.p);
  }
 
  

  toggleDisable2() {
    this.journeydate = true;
    this.searchDetails.bookingdate_to = "";
  }

  checkempty() {

    if (
      (this.searchDetails.bookingdate_from != "" &&
        this.searchDetails.bookingdate_to != "")
    ) {
      this.disableBtn = false;
    }

    if (
      (this.searchDetails.bookingdate_from == "" &&
        this.searchDetails.bookingdate_to == "")
    ) {
      this.disableBtn = false;
    }

    if (
      this.searchDetails.bookingdate_from == "" &&
      this.searchDetails.bookingdate_to != ""
    ) {
      this.disableBtn = true;
    }

    if (
      this.searchDetails.bookingdate_from != "" &&
      this.searchDetails.bookingdate_to == ""
    ) {
      this.disableBtn = true;
    }
  }

  checkStatus1() {
    this.mydate = this.searchDetails.bookingdate_from;
    this.checkempty();
    this.showsingle1 = true;
    this.showMultiple1 = true;

    if (
      this.searchDetails.bookingdate_from != "" &&
      this.searchDetails.bookingdate_to != ""
    ) {
      this.downd = false;
    } else {
      this.downd = true;
    }
  }


  reset3() {
    this.input3.value = "";

    this.searchDetails.bookingdate_from = "";
    this.tomorrow1 = "";
    this.isEmpty();
  }

  reset4() {
    this.input4.value = "";
    this.searchDetails.bookingdate_to = "";
    this.isEmpty();
  }

  checkDate() {
    this.invaliddate = false;
    if (
      this.searchDetails.bookingdate_to != " " &&
      this.searchDetails.bookingdate_to != "" &&
      this.searchDetails.bookingdate_to != null
    ) {
      if (
        this.searchDetails.bookingdate_from >=
        this.searchDetails.bookingdate_to
      ) {
        this.invaliddate = true;
      }
    }
  }

  incresedate() {
    var tomorrow = (document.getElementById("did") as HTMLInputElement).value;
    let temp = new Date(tomorrow);
    // console.log(tomorrow,"tomorrow");
    this.final = temp.setDate(temp.getDate());
    this.final = new Date(this.final);
  }
  keypresshandler(event) {
    var charCode = event.keyCode;
    //Non-numeric character range
    if (charCode > 31 && (charCode < 48 || charCode > 57)) return false;
  }

  downloadDsr(fileName,CREATED_DATE){
    this.isNoFileToDownloadError = false;
	  var req = {
		  "fileName": fileName,
      "created_date":CREATED_DATE
	  }
	  this.vernostService.downloadDsr(req).subscribe(response => {
		  response.text().then((resp) => {
        if(resp == 'false') {
          this.isNoFileToDownloadError = true;
          this.Errmessage = this.noFileToDownloadErrorMessage;
        } else {
          this.Errmessage = "";
          saveAs(response, fileName);
        }
      })
	  })
  }

  sendDsrEmail(){
     var req = {
		 "files":this.sendEmailReports
	 }
	 this.sendEmailReports = [];
	 this.vernostService.sendDsrEmailReq(req).subscribe(response => {
         if(response){
			this.sendEmailReports = [];
			this.searchData();
		 }
	 });
  }
  sendMailCheck(event,reportName,id,NEW_CREATED_DATE){
	if (event.target.checked) {
		this.sendEmailReports.push({"id": id, "fileName":reportName,'created_date':NEW_CREATED_DATE});
		console.log("sendEmailReports",this.sendEmailReports);
	  } else {
		for( var i = 0; i < this.sendEmailReports.length; i++){ 
    
			if ( this.sendEmailReports[i] === reportName) { 
				this.sendEmailReports.splice(i, 1); 
			}
		}
	  }
  }
}
